import customFetch from "../helpers/axios";
import { getUserCookie, setUserCookie } from "../context/cookieUtils";

// Devuelve un access token válido, refrescando si es necesario
// Úsalo antes de abrir un WebSocket o si necesitas el token fuera de customFetch
export async function getValidAccessToken() {
  const user = getUserCookie();
  const token = user?.access;
  if (!token) return null;

  function isJwtExpired(token) {
    try {
      const [, payload] = token.split(".");
      const { exp } = JSON.parse(atob(payload));
      return Date.now() >= exp * 1000;
    } catch {
      return true;
    }
  }

  if (!isJwtExpired(token)) {
    return token;
  }

  // Si está expirado, refresca y devuelve el nuevo
  const refresh = user?.refresh;
  if (!refresh) return null;
  const resp = await customFetch.post("api/auth/token/refresh/", { refresh });
  if (resp && resp.data && resp.data.access) {
    const updatedUser = { ...user, access: resp.data.access };
    setUserCookie(updatedUser);
    return resp.data.access;
  }
  return null;
}

// Devuelve el token actual, refrescando si es necesario
export async function refreshToken() {
  try {
    const user = getUserCookie();
    const refresh = user?.refresh;
    if (!refresh) {
      // No hay refresh token, forzar logout defensivo
      if (typeof window !== 'undefined') {
        document.cookie = "autenticator_user=; Max-Age=0; path=/";
        window.location.href = "/login";
      }
      return null;
    }
    const resp = await customFetch.post("api/auth/token/refresh/", { refresh });
    if (resp && resp.data && resp.data.access) {
      // Solo actualiza access, deja refresh igual
      const updatedUser = { ...user, access: resp.data.access };
      setUserCookie(updatedUser);
      return resp.data;
    }
    return null;
  } catch (e) {
    console.log("Error", e);
    return null;
  }
}

export async function getValidJwtToken(token) {
  // Si el token no existe, retorna null
  if (!token) return null;

  // Decodifica el JWT para ver si está expirado
  function isJwtExpired(token) {
    try {
      const [, payload] = token.split(".");
      const { exp } = JSON.parse(atob(payload));
      return Date.now() >= exp * 1000;
    } catch {
      return true;
    }
  }

  if (!isJwtExpired(token)) {
    return token;
  }

  // Si está expirado, intenta refrescarlo
  try {
    const user = getUserCookie();
    const refresh = user?.refresh;
    const resp = await customFetch.post("api/auth/token/refresh/", { refresh });
    if (resp && resp.data && resp.data.access) {
      // Solo actualiza access, deja refresh igual
      const updatedUser = { ...user, access: resp.data.access };
      setUserCookie(updatedUser);
      return resp.data.access;
    }
    return null;
  } catch (e) {
    return null;
  }
}
